import CuminCardRenewalCardGroup from 'features/membership/components/cumin/CuminCardRenewalCardGroup';
import { TEMPLATE_ALIAS_CODE } from 'features/membership/libs/const/aliasCode';
import { EARTH_FEATURE_CODES } from 'features/membership/libs/const/plugins/earthFeatureCodes';
import {
  CuminPagePageTemplateOptionKey,
  membershipPluginFeatureState,
  membershipPluginPageTemplateOptionState
} from 'features/membership/libs/recoil/selector';
import { PageTemplateOption } from 'features/membership/types';
import { FEATURES } from 'libs/features';
import _ from 'lodash';
import { FC } from 'react';
import { useRecoilValue } from 'recoil';

/**
 * カード紛失・再発行
 */
const CuminCardRenewal: FC = () => {
  const templateOptions = useRecoilValue<
    Record<CuminPagePageTemplateOptionKey, PageTemplateOption> | undefined
  >(membershipPluginPageTemplateOptionState(TEMPLATE_ALIAS_CODE.CUMIN));

  const earthFeatureCodes = useRecoilValue(membershipPluginFeatureState).earth;
  const isReissueFeatureActive = Boolean(
    earthFeatureCodes?.includes(_.camelCase(EARTH_FEATURE_CODES.REISSUE))
  );
  const isRelinkFeatureActive = Boolean(
    earthFeatureCodes?.includes(_.camelCase(EARTH_FEATURE_CODES.RELINK))
  );
  const isGetMemberFeatureActive = Boolean(
    earthFeatureCodes?.includes(_.camelCase(EARTH_FEATURE_CODES.GET_MEMBER))
  );

  return (
    <CuminCardRenewalCardGroup
      templateOptions={templateOptions}
      isReissueFeatureActive={isReissueFeatureActive}
      isRelinkFeatureActive={isRelinkFeatureActive}
      isGetMemberFeatureActive={isGetMemberFeatureActive}
      topPagePath={`${FEATURES.membership.path}/${TEMPLATE_ALIAS_CODE.CUMIN}`}
    />
  );
};

export default CuminCardRenewal;
